import TableCard from "../../tableCard/TableCard";
import { useEffect, useState } from "react";
import { CloseIcon, TickIcon, TrashIcon } from "../../kits/Icons";
import ColorSchema from "../../kits/Color";
import { swalFunc } from "../../../utils/helperFunction";
import { CustomTooltip } from "../../kits/tooltip/CustomTooltip";
import useAxios from "../../../services/useAxios";
import { SeparatorInput } from "../../kits/Inputs/Inputs";
export default function BankAccountList({
  data,
  type = "operation",
  mainDataHandler,
  bankName,
  setCustomerUpdater,
}) {
  const [content, setContent] = useState([]);
  const [header, setHeader] = useState([
    {
      type: "title",
      title: "نام بانک",

      name: "bankName",
    },
    {
      type: "description",
      title: " شماره کارت  ",
      name: "card_number_object",
    },
    {
      type: "title",
      title: "شماره حساب",
      name: "account_number",
    },

    {
      type: "",
      title: " شماره شبا ",
      name: "sheba_number_object",
    },
  ]);
  const { loading, execute: deactivate } = useAxios("api/Update_bankAccount");
  const deactivateCard = (val) => {
    return (
      <div>
        {val.status == -1 ? (
          <CustomTooltip title="فعال" placement="top" color="red_custom">
            <button
              onClick={() =>
                swalFunc(
                  `آیا از فعال کردن کارت بانکی خود مطمئن هستید؟`,
                  () =>
                    deactivate({
                      conditions: `id/=/${val.id}`,
                      keyvalues: `status,1`,
                    }).then(() => setCustomerUpdater((prev) => !prev)),
                  "warning"
                )
              }
            >
              {" "}
              <TickIcon
                color={
                  val.status == -1
                    ? ColorSchema.success_custom
                    : ColorSchema.danger_custom
                }
                width={20}
                height={20}
                containerIconClassName={`mx-auto `}
                style={{
                  border: `1px solid ${
                    val.status == -1
                      ? ColorSchema.success_custom
                      : ColorSchema.danger_custom
                  }`,
                  borderRadius: "50%",
                  cursor: "pointer",
                }}
              />
            </button>
          </CustomTooltip>
        ) : (
          <CustomTooltip title="غیرفعال" placement="top" color="red_custom">
            <button
              onClick={() =>
                swalFunc(
                  `آیا از غیرفعال کردن کارت بانکی خود مطمئن هستید؟`,
                  () =>
                    deactivate({
                      conditions: `id/=/${val.id}`,
                      keyvalues: `status,-1`,
                    }).then(() => setCustomerUpdater((prev) => !prev)),
                  "warning"
                )
              }
            >
              {" "}
              <CloseIcon
                color={
                  val.status == -1
                    ? ColorSchema.dark_custom
                    : ColorSchema.danger_custom
                }
                width={20}
                height={20}
                containerIconClassName={`mx-auto `}
                style={{
                  border: `1px solid ${
                    val.status == -1
                      ? ColorSchema.dark_custom
                      : ColorSchema.danger_custom
                  }`,
                  borderRadius: "50%",
                  cursor: "pointer",
                }}
              />
            </button>
          </CustomTooltip>
        )}
      </div>
    );
  };
  useEffect(() => {
    let op = {
      type: "description",
      title: " عملیات ",
      name: "operation",
    };
    if (
      type == "operation" &&
      header.find((h) => h.name == "operation") == undefined
    )
      setHeader((prev) => {
        return [...prev, op];
      });
    if (data != undefined) setContent(data);
  }, [type, data]);
  console.log("object bank account edit", data);
  return (
    <div style={{ fontSize: 13 }}>
      {content.map((val, ind) => {
        console.log("object val", val);
        return (
          <div className="position-relative " onClick={(e) => console.log(val)}>
            {type != "operation" ? (
              <>
                {" "}
                <TableCard
                  column={header}
                  content={{
                    ...val,
                    bankName: bankName?.filter((a) => a.value == val.bank_id)[0]
                      ?.label,
                    operation: deactivateCard(val),
                    card_number_object: (
                      <div>{val.card_number.formattedValue}</div>
                    ),
                    sheba_number_object: (
                      <div>{val.sheba_number.formattedValue}</div>
                    ),
                  }}
                  bg={
                    val.status == -1
                      ? "dark_light_custom"
                      : "primary_light_custom"
                  }
                  widthParent={"90%"}
                  showSelect="false"
                ></TableCard>
                <div
                  className="position-absolute cursor-pointer"
                  style={{
                    top: -8,
                    right: 25,
                    backgroundColor: ColorSchema.red_custom,
                    borderRadius: "50%",
                  }}
                  onClick={() => {
                    mainDataHandler("removeAccount", "", val.index);
                  }}
                >
                  {" "}
                  <TrashIcon color="white" containerIconClassName="p-1" />
                </div>
              </>
            ) : (
              <TableCard
                column={header}
                content={{
                  ...val,
                  bankName: bankName?.filter((a) => a.value == val.bank_id)[0]
                    ?.label,
                  operation: deactivateCard(val),
                  card_number_object: (
                    <SeparatorInput
                      style={{ color: ColorSchema.primary_custom }}
                      inputClassName="bg-transparent text-center"
                      inputValue={val?.card_number}
                      formatCustom="####-####-####-####"
                      label=""
                      inputSize="text"
                      activate="readOnly"
                      plaintext={true}
                    />
                  ),
                  sheba_number_object: (
                    <SeparatorInput
                      style={{ color: ColorSchema.primary_custom }}
                      inputClassName="bg-transparent text-center"
                      inputValue={val?.sheba_number}
                      formatCustom="IR-########################"
                      label=""
                      inputSize="text"
                      activate="readOnly"
                      plaintext={true}
                    />
                  ),
                }}
                bg={
                  val.status == -1
                    ? "dark_light_custom"
                    : "primary_light_custom"
                }
                widthParent={"90%"}
                showSelect="false"
              ></TableCard>
            )}
          </div>
        );
      })}
    </div>
  );
}
